import React from 'react';
import { useLoaderState } from '../common/state';

export const HeaderLoadingBar: React.FC = () => {
    const requests = useLoaderState((state) => state.requests);
    return (
        <>
            {requests > 0 ? (
                <div className={'infinite-loader-bar-container'}>
                    <div className={'infinite-loader-bar'} data-testid={'infinite-loader-bar'} />
                </div>
            ) : null}
        </>
    );
};
